module.exports = __webpack_public_path__ + "static/media/SV.27bb97e9.jpg";